import React from "react";
import IntegratedExternalAgentApp from "../../components/IntegratedExternalAgentApp";

export default function IntegratedMarketingApp() {
  return <IntegratedExternalAgentApp agent="marketing" title="AzentMart AI Marketing Agent" />;
}
